import { render, staticRenderFns } from "./JsonObject.vue?vue&type=template&id=56ece7fb&"
import script from "./JsonObject.vue?vue&type=script&lang=js&"
export * from "./JsonObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports